import React from 'react'

const SvgMoonOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.658 18.983c-2.635-.914-4.975-2.78-6.476-5.454A12.444 12.444 0 019.865 4.84c-2.328 1.415-3.889 4.022-3.889 7.001 0 4.488 3.54 8.126 7.905 8.126a7.697 7.697 0 003.777-.985zm2.37-1.497c.813.123 1.302 1.084.711 1.67C18.962 20.916 16.545 22 13.881 22 8.424 22 4 17.452 4 11.842c0-4.694 3.098-8.645 7.307-9.81.793-.218 1.342.707 1.026 1.486a10.393 10.393 0 00.56 8.995c1.573 2.8 4.247 4.54 7.135 4.973z'
    />
  </svg>
)

export default SvgMoonOutline
